module.exports = __webpack_public_path__ + "tv.svg";


//////////////////
// WEBPACK FOOTER
// ./src/js/components/pages/newLandingPage/block-devices/assets/tv.svg
// module id = 1151
// module chunks = 10